import React from "react";
import Form from "../components/register-form/Form";

const Register = () => {
  return (
    <React.Fragment>
      <Form />
    </React.Fragment>
  );
};

export default Register;
